import { render } from "./CreateWorkstationModal.vue?vue&type=template&id=8157403e&ts=true"
import script from "./CreateWorkstationModal.vue?vue&type=script&lang=ts"
export * from "./CreateWorkstationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__